import React, { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../../assets/images/logo.svg";
import { demoContext } from "../../../shared/store/contexts";

const LoginPage = () => {
  const navigate = useNavigate();

  const { orgId } = useContext(demoContext);

  useEffect(() => {
    if (orgId) {
      navigate(`/dashboard`);
    }
  }, [orgId]);

  return (
    <section className="relative bg-white h-screen flex justify-center items-center">
      <div className="absolute top-0 left-0 p-8">
        <img className=" " src={logo} alt="logo" />
      </div>

      <h1 className="text-3xl font-bold text-purple-600 p-8">
        Social Safety Net Organisation Demo
      </h1>
    </section>
  );
};

export default LoginPage;
